import './App.css';
import Button from './components/Button';
import Header from './components/Header';
import Headline from './components/Headline';


function App() {
  return (
    <div className="wrapper">
      <Header />
      <Headline />
      <Button />
    </div>
  );
}

export default App;
